export default __webpack_public_path__ + "static/media/uefa24-prediction-bm.604089ff.webp";